import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { DistributorContract } from '../../models/distributor-contract';
import { DistributorContractsService } from '../services/distributor-contracts.service';

@Injectable()
export class DistributorContractResolver implements Resolve<DistributorContract>
{
	private distributorContractsService: DistributorContractsService;

	constructor(distributorContractsService: DistributorContractsService)
	{
		this.distributorContractsService = distributorContractsService;
	}

	resolve(route: ActivatedRouteSnapshot): Promise<DistributorContract>
	{
		return this.distributorContractsService.getDistributorContract(+route.params['contractId']);
	}
}



// WEBPACK FOOTER //
// ./src/app/distributors/resolvers/distributor-contract.resolver.ts